document.addEventListener('DOMContentLoaded', () => {
    const FOCUSABLE = '[autofocus], [data-dialog-close], a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function getTrigger(dialog) {
        return document.querySelector(`.gallery-trigger[aria-controls="${dialog.id}"]`);
    }

    function openDialog(trigger, dialog) {
        trigger.setAttribute('aria-expanded', 'true');
        dialog._returnFocusEl = trigger;
        document.body.style.overflow = 'hidden';

        dialog.classList.add('is-opening');
        dialog.showModal();
        requestAnimationFrame(() => dialog.classList.remove('is-opening'));

        (dialog.querySelector(FOCUSABLE) || dialog).focus();
    }

    function closeDialog(trigger, dialog) {
        trigger.setAttribute('aria-expanded', 'false');
        if (!dialog.open) return;

        dialog.classList.add('is-closing');
        setTimeout(() => {
            dialog.classList.remove('is-closing');
            dialog.close();
            document.body.style.overflow = '';
            dialog._returnFocusEl?.focus();
        }, 200);
    }

    document.querySelectorAll('dialog.gallery-dialog').forEach(dialog => {
        dialog.addEventListener('cancel', e => {
            e.preventDefault();
            closeDialog(getTrigger(dialog), dialog);
        });

        dialog.addEventListener('close', () => {
            const trigger = getTrigger(dialog);
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
            dialog._returnFocusEl?.focus();
        });

        dialog.addEventListener('click', e => {
            if (e.target === dialog) closeDialog(getTrigger(dialog), dialog);
        });
    });

    document.addEventListener('click', e => {
        const trigger = e.target.closest('.gallery-trigger');
        if (trigger) {
            const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
            if (dialog) openDialog(trigger, dialog);
            return;
        }

        const closeBtn = e.target.closest('[data-dialog-close]');
        if (closeBtn) {
            const dialog = closeBtn.closest('dialog.gallery-dialog');
            if (dialog) closeDialog(getTrigger(dialog), dialog);
        }
    });
});
